<div class="page-root">
  <div class="page-two-column-body">
    <div [formGroup]="registerForm" class="page-column">
      <div class="column">
        <div class="typo-h1">{{ "patient.add" | transloco }}</div>
      </div>

      <div class="form">
        <div class="row">
          <mat-form-field class="min-width-m" hideRequiredMarker subscriptSizing="dynamic">
            <mat-label>{{ "form.label.firstName" | transloco }}</mat-label>
            <input formControlName="firstName" matInput>
          </mat-form-field>

          <mat-form-field class="min-width-m" hideRequiredMarker subscriptSizing="dynamic">
            <mat-label>{{ "form.label.lastName" | transloco }}</mat-label>
            <input formControlName="lastName" matInput>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field class="min-width-s" floatLabel="always" hideRequiredMarker subscriptSizing="dynamic">
            <mat-label>{{ "form.label.dateOfBirth" | transloco }}</mat-label>
            <input [placeholder]="'form.placeholder.date' | transloco" appDateMask formControlName="dateOfBirth" matInput>
            <mat-icon matSuffix>calendar_month</mat-icon>
            <mat-error>{{ 'form.validation.dateOfBirth' | transloco }}</mat-error>
          </mat-form-field>

          <mat-form-field class="min-width-s" floatLabel="always" hideRequiredMarker subscriptSizing="dynamic">
            <mat-label>{{ "form.label.sex" | transloco }}</mat-label>
            <mat-select [placeholder]="'form.placeholder.select' | transloco" formControlName="sex">
              @for (sex of sexes; track $index) {
                <mat-option [value]="sex">
                  {{ "sex." + sex | transloco }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field class="min-width-m" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.street" | transloco }}</mat-label>
          <input formControlName="street" matInput>
        </mat-form-field>

        <div class="row">
          <mat-form-field class="min-width-s" hideRequiredMarker subscriptSizing="dynamic">
            <mat-label>{{ "form.label.zipCode" | transloco }}</mat-label>
            <input formControlName="zipCode" matInput>
          </mat-form-field>

          <mat-form-field class="min-width-s" hideRequiredMarker subscriptSizing="dynamic">
            <mat-label>{{ "form.label.city" | transloco }}</mat-label>
            <input formControlName="city" matInput>
          </mat-form-field>
        </div>

        <div class="row">
          <mat-form-field class="min-width-xs" floatLabel="always" hideRequiredMarker subscriptSizing="dynamic">
            <mat-label>{{ "form.label.country" | transloco }}</mat-label>
            <mat-select [placeholder]="'form.placeholder.select' | transloco" formControlName="countryCode">
              @for (group of countryGroups; track group.labelKey) {
                <mat-optgroup [label]="group.labelKey | transloco">
                  @for (country of group.countries; track country.code) {
                    <mat-option [value]="country.code">
                      {{ country.name }}
                    </mat-option>
                  }
                </mat-optgroup>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="min-width-xs" floatLabel="always" hideRequiredMarker subscriptSizing="dynamic">
            <mat-label>{{ "form.label.language" | transloco }}</mat-label>
            <mat-select [placeholder]="'form.placeholder.select' | transloco" formControlName="language">
              @for (language of languages; track $index) {
                <mat-option [value]="language">
                  {{ "language." + language | transloco }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <mat-form-field class="min-width-m" hideRequiredMarker subscriptSizing="dynamic">
          <mat-label>{{ "form.label.email" | transloco }}</mat-label>
          <input formControlName="email" matInput>
          <mat-error>{{ 'form.validation.email' | transloco }}</mat-error>
        </mat-form-field>

        <div class="column">
          <div class="row">
            <app-phone-input class="min-width-m" formControlName="phone" label="form.label.phone"/>

            <app-phone-input class="min-width-m" formControlName="mobile" label="form.label.mobile"/>
          </div>

          @if (phoneRequired) {
            <mat-error class="error">{{ 'form.validation.phoneRequired' | transloco }}</mat-error>
          }
        </div>

        @if (error) {
          <mat-error>{{ error }}</mat-error>
        }

        <div class="actions">
          <app-text-button (click)="register()" [text]="'patient.add' | transloco" colorVariant="primary" leadingIcon="check_circle" type="rounded"/>
          <app-text-button mat-dialog-close [text]="'button.cancel' | transloco" colorVariant="outlined-neutral" leadingIcon="close"/>
        </div>
      </div>
    </div>

  </div>
</div>
